module.exports = __webpack_public_path__ + "static/media/Page 1.9d985933.mp4";